import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth/auth.service";
import { ToastService } from "../../services/toast.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderService } from "../../services/loader.service";
import { UserRole } from '../../common/models/user/user-role.enum';
import { DialogService } from '../../services/dialog/dialog.service';
import { PageTitleService } from '../../services/page-title.service';

@Component({
  selector: 'psc-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  formGroup: FormGroup;
  formHasError: boolean = false;
  loginExpired: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.login)
     */
    this.pageTitleService.setTitle('title.login');
  }

  ngOnInit(): void {
    const param = this.route.snapshot.queryParamMap.get('loginExpired');
    this.loginExpired = param === 'true';
    if (this.loginExpired) {
      /**
       * t(token_expired)
       *  */
      this.toastService.showErrorToast('token_expired');
    }
    this.formGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  onSubmit() {
    if(!this.formGroup.valid) {
      return;
    }
    this.loaderService.showLoader();
    this.authService.login(this.formGroup.controls['email'].value, this.formGroup.controls['password'].value ).subscribe({
      next: () => {
        this.toastService.showSuccessToast('toast.login.success');
        if (this.authService.userHasRole(UserRole.ROLE_ADMIN)) {
          this.router.navigate(['/admin']);
        } else {
          this.router.navigate(['/customer']);
        }
      },
      error: () => {
         this.formHasError = true;
      }
    }).add(() => {
      this.loaderService.hideLoader();
    });
  }
}
